export const EDITOR_NAMESPACE = 'https://www.front-crafter.nl/jigsaw';

export enum NodeType {
  NO_TYPE,
  ELEMENT,
  ATTRIBUTE,
  TEXT,
  CDATA_SECTION,
  ENTITY_REFERENCE,
  ENTITY,
  PROCESSING_INSTRUCTION,
  COMMENT,
  DOCUMENT,
  DOCUMENT_TYPE,
  DOCUMENT_FRAGMENT,
  NOTATION,
}
